<div class="snackbar-container">
    <img [src]="data.icon" title='notification image' class='snackbar-icon' />
    <div class="snackbar-content">
        <div class="snackbar-title" [innerHTML]="data.title"></div>
        <div class="snackbar-description" [innerHTML]="data.description"></div>
    </div>
</div>
<div class="snackbar-button-row">
    <button mat-flat-button (click)="dismiss()" class="dismiss-btn">{{ data.dismissLabel ?? "Close" }}</button>
    @if (data.details) {
        <button mat-stroked-button (click)="showDetails()" class="dismiss-btn">Details</button>
    }
</div>